import { DateUtils } from '@eo-storefronts/eo-core'
import { Box } from '@mui/material'
import { MouseEvent, useEffect, useState } from 'react'
import DeliveryMethodsDateButtonGroup from '~/src/components/delivery-methods/DeliveryMethodsDateButtonGroup'
import { useUpdateCheckoutTime } from '~/src/hooks/checkout/useUpdateCheckoutTime'
import { useEoState } from '~/src/hooks/useEoState'
import { CHECKOUT_FORM_STATE, CheckoutFormState } from '~/src/stores/checkout'
import { useCanOrderOnDay } from '~/src/hooks/delivery-methods/useCanOrderOnDay'
import DeliveryMethodsDatePicker from '~/src/components/delivery-methods/delivery-methods-date-picker'

const DeliveryMethodsDateContainer = () => {
  const [ checkoutForm, setCheckoutForm ] = useEoState(CHECKOUT_FORM_STATE)
  const { updateCheckoutTime } = useUpdateCheckoutTime()
  const [ selectedButtonValue, setSelectedButtonValue ] = useState<string>('')
  const { canOrderOnDay } = useCanOrderOnDay()

  const handleOnChange = (event: MouseEvent, value: string) => {
    if (!value) {
      return
    }

    setSelectedButtonValue(value)

    if (value !== 'today') {
      setCheckoutForm((state: CheckoutFormState) => ({
        ...state,
        delivery_method: {
          ...state.delivery_method,
          asap: false
        }
      }))
    }

    if (value === 'today' || value === 'tomorrow') {
      updateCheckoutTime(value === 'today' ? new Date() : DateUtils.addDays(1))
    }
  }

  useEffect(() => {
    if (!checkoutForm.delivery_method.time) {
      return
    }

    const checkoutDate = new Date(checkoutForm.delivery_method.time)

    if (DateUtils.isSameDate(new Date(), checkoutDate) && canOrderOnDay(new Date())) {
      return setSelectedButtonValue('today')
    }

    if (DateUtils.isSameDate(DateUtils.addDays(1), checkoutDate) && canOrderOnDay(DateUtils.addDays(1))) {
      return setSelectedButtonValue('tomorrow')
    }

    setSelectedButtonValue('pick')
  }, [ checkoutForm.delivery_method.time, checkoutForm.delivery_method.pickupPoint ])

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        flexShrink: 0,
        flexWrap: 'wrap'
      }}
    >
      <DeliveryMethodsDateButtonGroup onChange={handleOnChange} value={selectedButtonValue} />
      {selectedButtonValue === 'pick' && <DeliveryMethodsDatePicker />}
    </Box>
  )
}

export default DeliveryMethodsDateContainer
